import React from "react";
import { connect } from "react-redux";
import { startLogin } from "../actions";

export const LoginPage = ({ startLogin }) => (
  <form
    className="box-layout"
    onSubmit={e => {
      e.preventDefault();
      startLogin(e.target[0].value, e.target[1].value);
    }}>
    <div className="box-layout__box" style={{ width: 400 }}>
      <h1 className="box-layout__title">Tuuli admin login</h1>
      <label>Email:</label>
      <br />
      <input className="standard-input" type="email" required />
      <br />
      <label>Jelszó:</label>
      <br />
      <input className="standard-input" type="password" required />
      <br />
      <br />
      <button className="button" type="submit">
        Login
      </button>
      <br />
    </div>
  </form>
);

export default connect(
  null,
  {
    startLogin,
  }
)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage.js